
import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {LB_CODE, LB_ACTIVE, LB_TITLE, LB_APPLICATIVE, LB_UDN} from "../../../components/i18n/i18n";
import {PH_CODE, PH_TITLE} from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {applicativeProvider} from "../../../providers/applicativeProvider";
import {udnProvider} from "../../../providers/udnProvider";






const NotificationFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const {fbDataBase} = app

    const [status, setStatus] = useState(filter?.status || null);
    const [applicative, setApplicative] = useState(filter?.applicative || null)
    const [udn, setUdn] = useState(filter?.udn || null)

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code || '',
            title: filter?.title || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {  ...data, }
        };

        if (applicative !== undefined && applicative !== null)
            dataFilter.item.applicative = applicative;

        if (udn !== undefined && udn !== null)
            dataFilter.item.udn = udn;

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        setApplicative(null)
        reset({
            code: '',
            title: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{LB_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>



                <Col md="4">
                    <FormGroup>
                        <SelectGeneric
                            title={LB_APPLICATIVE}
                            initialValue={applicative}
                            setExternalValue={setApplicative}
                            provider={applicativeProvider}
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <SelectGeneric
                            title={LB_UDN}
                            initialValue={udn}
                            setExternalValue={setUdn}
                            provider={udnProvider}
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label>{LB_TITLE}</Label>
                        <Input
                            type="text"
                            name="title"
                            placeholder={PH_TITLE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>¿La notificación esta activa?</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(NotificationFilters)